// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2aROR","search":"Settings_search__1MM9I","filter":"Settings_filter__3UqWM"};